import React from 'react';

import Tooltip from '../../library/tooltip/tooltip';
import {
  SnowflakeRegularIcon,
  SunBrightSolidIcon
} from '../../shared/icons/icons';

import './winter-tire-badge.scss';

interface WinterTireBadgeProps {
  isWinterOnly?: boolean;
}

function WinterTireBadge(props: WinterTireBadgeProps) {
  const { isWinterOnly } = props;

  return (
    <Tooltip
      className="winter-tire-badge"
      content={isWinterOnly ? 'Winter Tire' : 'Multi-Season Tire'}
      hoverOver
      render={
        <>
          {isWinterOnly && (
            <div
              className="winter-tire-badge__winter-only"
              styleName="winter-only"
            >
              <SnowflakeRegularIcon />
            </div>
          )}

          {!isWinterOnly && (
            <div
              className="winter-tire-badge__winter-capable"
              styleName="winter-capapble"
            >
              <div
                className="winter-tire-badge__winter-capable-sun"
                styleName="winter-capable-sun"
              >
                <SunBrightSolidIcon />
              </div>
              <div
                className="winter-tire-badge__winter-capable-snow"
                styleName="winter-capable-snow"
              >
                <SnowflakeRegularIcon />
              </div>
            </div>
          )}
        </>
      }
    />
  );
}

export default WinterTireBadge;
